(ns frontend.ui.component.radio-group.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]))

(defn label
  []
  {:display        "flex"
   :flex-direction "row"
   :line-height    "18px"
   :cursor         "pointer"
   :user-select    "none"})

(defn hidden-input
  []
  {:position "absolute"
   :opacity  0
   :cursor   "pointer"
   :height   0
   :width    0})

(defn icon
  [{:keys [checked? disabled?]}]
  (merge
   {:padding-right "10px"
    :font-size     "18px"}
   (if (and checked? (not disabled?))
     {:color (theme/color [:radio-group :icon :checked])}
     {:color (theme/color [:radio-group :icon :unchecked])})))
